// либо список, либо заглушка - это шаблон для ноды
export const renderSuggestions = (suggestions: IDadataResponseNode[], type: string): string => {
  const txt = suggestions.length > 0
    ? `<ul>
        ${ suggestions.map((suggest, index) => suggestItemTemplate(suggest, index, type)).join('') }
        </ul>`
    : `<div class='form-suggestion__empty'>Ничего не найдено</div>`

  return txt
}

// рулим, какой текст показывать
const suggestItemTemplate = (suggest: IDadataResponseNode, index: number, type: string): string => {
  let txt = ''
  switch (type) {
    case 'party':
      txt = partyTemplate(suggest as IDadataResponseNode<IParty>, index)
      break
    default:
      txt = defaultTemplate(suggest, index)
      break
  }

  return txt
}

// шаблон для одной организации
const partyTemplate = (suggest: IDadataResponseNode<IParty>, index: number): string => (
  `<li class='form-suggestion__item' data-selector='dadataSuggestion' data-index='${ index }'>
      <div class='form-suggestion__title'>${suggest.value}</div>
      <div class='form-suggestion__info'>
        <span class='form-suggestion__inn'>${suggest.data.inn}</span>
        ${suggest.data.address.value}
      </div>
    </li>`
)

// шаблон по умолчанию
const defaultTemplate = (suggest: IDadataResponseNode, index: number): string => (
  `<li class='form-suggestion__item' data-selector='dadataSuggestion' data-index='${ index }'>
      <div class='form-suggestion__title'>${suggest.value}</div>
    </li>`
)
